// extracted by mini-css-extract-plugin
export default {"placeholder-color-light":"Image_placeholder-color-light__sOZfC","placeholder":"Image_placeholder__yK-jp"};